import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="footer px-4">
      <div className="content has-text-centered">
        <p>
          <strong>Cloud Platform Programming</strong> project by <strong>Ashish Patel</strong>
        </p>
      </div>
    </footer>
  )
}

export default Footer
